// T4/100A01: Pestañas del menú lateral visibles para el usuario, agrupadas.
// Misma lógica que components/home/index.js:44-51 (se movió aquí para que el
// inicio y los submódulos usen la misma fuente).
import { useMemo } from "react";
import { TABS } from "components/home/tabs";
import { visibleTabs } from "components/home/menu";
import { usePermiso } from "components/Permisos/PermisosContext";

export const groupTabs = (tabs) => ({
  main: tabs.filter((t) => t.group === "main"),
  global: tabs.filter((t) => t.group === "global"),
  bottom: tabs.filter((t) => t.group === "bottom"),
});

export const useSidebarTabs = () => {
  const { allow } = usePermiso();
  // T2/100A82: + diagnóstico de pestañas visibles (solo desarrollo). Antes:
  // return useMemo(() => groupTabs(visibleTabs(TABS, allow)), [allow]);
  return useMemo(() => {
    const visible = visibleTabs(TABS, allow);
    if (process.env.NODE_ENV === "development") {
      console.log(`[MENÚ] pestañas visibles ${visible.length}/${TABS.length}:`, visible.map((t) => t.key).join(", "));
    }
    return groupTabs(visible);
  }, [allow]);
};
